import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomerOverViewService } from '../../customer-overview.service';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';
import { Customer, Pager, SidebarOptions } from '~core/models';
import { CampaignService, CustomerService, NavigationService, PaginationService, ScreenSizeService } from '~core/services';
import { SidebarService } from '~core/components/sidebar/sidebar.service';

/**
 * Component that displays the campaign activity on a separate page
 */
@UntilDestroy()
@Component({
  selector: 'app-campaign-activity-page',
  templateUrl: './campaign-activity-page.component.html',
  styleUrls: ['../../customer-overview.component.scss']
})
export class CampaignActivityPageComponent implements OnInit, OnDestroy {
  public loading: boolean;
  public campaignActivity: any;
  public pager: Pager;
  public itemsPerPage: number = 5;
  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];
  public customer: Customer;

  constructor(
    public customerOverviewService: CustomerOverViewService,
    public sidebarService: SidebarService,
    public customerService: CustomerService,
    public campaignService: CampaignService,
    public tablesTranslations: TablesTranslations,
    public paginationService: PaginationService,
    public navigationService: NavigationService,
    public route: ActivatedRoute,
    public router: Router,
    private screenSizeService: ScreenSizeService,

  ) {
    if (this.screenSizeService.screenSize === 'desktop') {
      this.sidebarService.setSidebar(new SidebarOptions(true, true));
    } else {
      this.sidebarService.setSidebar(new SidebarOptions(false, true));
    }

    this.navigationService.setCurrentPage('campaigns');
    this.navigationService.setCurrentBreadcrumbs(['crm', 'customerProfile']);
    this.campaignService.castActivity.pipe(untilDestroyed(this))
      .subscribe(act => this.campaignActivity = act);
    this.customerService.castSelectedCustomer.pipe(untilDestroyed(this))
      .subscribe(customer => this.customer = customer);
  }
  public ngOnInit(): void {
    if (this.customer.hasEmail) {
      this.loading = true;
      this.setUp();
      if (this.checkExistingData()) {
        this.getCampaignActivity();
      } else {
        this.loading = false;
      }
    }
  }

  public ngOnDestroy(): void {
    this.customerOverviewService.toggleAllModal(false);
  }

  /**
   * Retrieves the campaign activity and calls for the pager
   */
  public getCampaignActivity(): void {
    this.campaignService.getCampaignActivity(this.customer.id).pipe(untilDestroyed(this))
      .subscribe({
        next: (res: any) => {
          this.campaignService.setCampaignActivity(res);
          this.loading = false;
        },
        error: (error: Error) => {
          this.loading = false;
        }
      });
  }

  /**
   * Opens the campaign URL in a new browser tab
   */
  public openCampaignPage(event: any): any {
    if (event.campaignUrl !== null) {
      window.open(event.campaignUrl, '_blank');
    }
  }

  /**
   * Adds the columns and keys for the table
   */
  private setUp(): void {
    this.columns.push(this.tablesTranslations.i18nTimestamp, this.tablesTranslations.i18nCampaignTitle, this.tablesTranslations.i18nAction);
    this.keys.push(['timestamp', 'campaignTitle', 'translatedCampaignActivityAction']);
  }

  /**
   * Checks if data exists before trying to load it from the server
   */
  private checkExistingData(): boolean {
    return this.campaignActivity == null;
  }
}
